module.exports = __webpack_public_path__ + "img/b01.d53e00a1.png";